import { Module } from '@nestjs/common';
import { JwtModule } from '@nestjs/jwt';
import { ScheduleModule } from '@nestjs/schedule';
import { ServeStaticModule } from '@nestjs/serve-static';
import { TypeOrmModule } from '@nestjs/typeorm';
import { join } from 'path';
import { DataSource } from 'typeorm';
import { appConfig } from '../../config';
import { MailerModule } from './__common__/mailer/mailer.module';
import { AdobeAcrobatApiModule } from './adobe-acrobat-api/adobe-acrobat-api.module';
import { AppDataSource } from './app-datasource';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { AuthModule } from './auth/auth.module';
import { UsersModule } from './users/users.module';
import { WfxModule } from './wfx/wfx.module';


@Module({
  imports: [
    MailerModule,
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: "mysql",
      timezone: 'Z',
      host: appConfig.database.host,
      port: appConfig.database.port,
      username: appConfig.database.username,
      password: appConfig.database.password,
      database: appConfig.database.dbName,
      autoLoadEntities: true,
      synchronize: false,
      logging: true,
      extra: {
        connectionLimit: 20
      }
    }),
    ServeStaticModule.forRoot({
      // rootPath: join(__dirname, '..', '..', '..', '..', 'dist','packages','services','common','upload_files'),
      rootPath: join(__dirname, '../../../../', 'files'),
      serveRoot: '/static',
      serveStaticOptions: {
        redirect: false,
        index: false
      }
    }),
    ServeStaticModule.forRoot({
      rootPath: join(__dirname, '../../../../', 'image_files'),
      serveRoot: '/images',
      serveStaticOptions: {
        redirect: false,
        index: false
      }
    }),
  
    ServeStaticModule.forRoot({
      rootPath: join(__dirname, '../../../../', 'pdf_files'),
      serveRoot: '/techpack_pdf',
      serveStaticOptions: {
        redirect: false,
        index: false
      }
    }),

    UsersModule,
    AuthModule, JwtModule, AdobeAcrobatApiModule, WfxModule],
  controllers: [AppController],
  providers: [AppService, {
    provide: DataSource,
    useFactory: async () => {
      await AppDataSource.initialize()
        .then(() => {
          console.log('Data Source has been initialized!');
        })
        .catch((err) => {
          console.error('Error during Data Source initialization', err);
        });
      // await AppDataSource1.initialize()
      //   .then(() => {
      //     console.log('Data Source has been initialized!');
      //   })
      //   .catch((err) => {
      //     console.error('Error during Data Source initialization', err);
      //   });
      // await AppDataSource2.initialize()
      //   .then(() => {
      //     console.log('Data Source has been initialized!');
      //   })
      //   .catch((err) => {
      //     console.error('Error during Data Source initialization', err);
      //   });
    }
  }],
})
export class AppModule { }
